import type { FaireProductEntity } from "../../entity_types/product";

export const p_4fryh5djpm: FaireProductEntity = {
  token: "p_4fryh5djpm",
  type: "product",
  name: 'Minnesota State Plush (8") \u2013 Tiny Loon in Hands',
  brandName: "Stuffed States USA",
  imageUrl:
    "https://cdn.faire.com/fastly/9690066fa1df949399a0731683967dc357142033be74cd8b75948312d32cd71d.jpeg",
  priceDollars: 0,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/982dae06589539824b17d1a2a02f3eb5b2cb7c27877d321ee31298f6616fceb9.png",
  weight: 1,
  dimensions: {
    width: 6,
    height: 6,
    depth: 4,
  },
  inStock: true,
};
